import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid2, MenuItem, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
const SystemForm = ({ formData, setSelectedSystem, selectedSystem, disabled = false }) => {
    const { t } = useTranslation();
    const { systems } = useSelector((state) => state.systemDetail);
    const [assetSystems, setAssetSystems] = useState([]);
    const { control, formState: { errors }, setValue } = useFormContext();
    const handleSystemChange = (selectedName) => {
        const system = formData.find((system) => system.systemName === selectedName);
        if (system) {
            var id = selectedSystem?.id;
            setSelectedSystem({
                ...system,
                systemId: system.id,
                id: id,
                isActive: true
            });
            setValue('id', system.id);
            setValue('systemName', system.systemName);
            setValue('systemType', system.systemType);
            setValue('description', system.description);
            setValue('cameraUrl', system.cameraUrl);
            setValue('jetsonId', system.jetsonId);
        }
    };
    useEffect(() => {
        if (systems?.data.data) {
            const systemIdList = systems?.data?.data?.map((item) => item.systemId) || [];
            setAssetSystems(systemIdList);
        }
    }, [systems]);
    useEffect(() => {
        if (selectedSystem) {
            setValue('systemName', selectedSystem?.systemName);
            setValue('systemType', selectedSystem?.systemType);
            setValue('description', selectedSystem?.description);
            setValue('cameraUrl', selectedSystem?.cameraUrl);
            setValue('jetsonId', selectedSystem?.jetsonId);
        }
    }, [selectedSystem, setValue]);
    return (_jsxs(Grid2, { container: true, spacing: 2, children: [_jsx(Grid2, { size: 6, children: _jsx(Controller, { name: 'systemName', control: control, rules: { required: t('RequiredField') }, 
                    // disabled={selectedSystem?.id ? true : false}
                    render: ({ field }) => (_jsx(TextField, { ...field, select: true, label: t('SystemName'), fullWidth: true, disabled: disabled, error: !!errors.systemName, helperText: errors.systemName?.message, onChange: (e) => {
                            field.onChange(e);
                            handleSystemChange(e.target.value);
                        }, children: formData?.length > 0 ? ((selectedSystem?.id
                            ? formData
                            : formData.filter((system) => system.isActive === false && !assetSystems?.includes(system.id))).map((system) => (_jsx(MenuItem, { value: system.systemName, children: system.systemName }, system.id)))) : (_jsxs(MenuItem, { value: '', disabled: true, children: [t('NoSystemsAvailable'), " "] })) })) }) }), _jsx(Grid2, { size: 6, children: _jsx(Controller, { name: 'systemType', control: control, rules: { required: t('RequiredField') }, 
                    // disabled
                    render: ({ field }) => (_jsx(TextField, { ...field, label: t('SystemType'), fullWidth: true, select: true, disabled: disabled, error: !!errors.systemType, helperText: errors.systemType?.message, onChange: (e) => {
                            field.onChange(e);
                        }, children: formData?.length > 0 ? ((selectedSystem?.id
                            ? formData
                            : formData.filter((system) => system.isActive === false && !assetSystems?.includes(system.id))).map((system) => (_jsx(MenuItem, { value: system.systemType, children: system.systemType }, system.id)))) : (_jsxs(MenuItem, { value: '', disabled: true, children: [t('NoSystemsAvailable'), " "] })) })) }) }), _jsx(Grid2, { size: 6, children: _jsx(Controller, { name: 'cameraUrl', control: control, rules: { required: t('RequiredField') }, render: ({ field }) => (_jsx(TextField, { ...field, label: 'Camera URL', fullWidth: true, disabled: disabled, error: !!errors.cameraUrl, helperText: errors.cameraUrl?.message })) }) }), _jsx(Grid2, { size: 6, children: _jsx(Controller, { name: 'jetsonId', control: control, rules: {
                        required: t('RequiredField'),
                        pattern: {
                            value: /^[a-zA-Z0-9]*$/,
                            message: t('Only alphanumeric characters are allowed')
                        }
                    }, render: ({ field }) => (_jsx(TextField, { ...field, label: 'Jetson ID', fullWidth: true, disabled: disabled, error: !!errors.jetsonId, helperText: errors.jetsonId?.message })) }) }), _jsx(Grid2, { size: 12, children: _jsx(Controller, { name: 'description', control: control, rules: { required: t('RequiredField') }, render: ({ field }) => (_jsx(TextField, { ...field, label: 'Description', multiline: true, rows: 4, fullWidth: true, disabled: disabled, error: !!errors.description, helperText: errors.description?.message, onChange: (e) => {
                            field.onChange(e);
                        } })) }) })] }));
};
export default SystemForm;
